module.exports = __webpack_public_path__ + "static/img/21.2ab4ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/21.png
// module id = UtoM
// module chunks = 0